import { Reveal, SectionLabel } from "./Reveal";

const testimonials = [
  {
    quote:
      "Ich hab von Websites keine Ahnung — musste ich auch nicht. Stephan hat alles erklärt, alles übernommen, und seit dem Relaunch klingelt das Telefon deutlich öfter.",
    name: "Markus T.",
    role: "Inhaber, Sanitärbetrieb, Düsseldorf",
    metric: "+40 % Anfragen in 3 Monaten",
  },
  {
    quote:
      "Endlich eine Seite, die auf dem Handy gut aussieht. Unsere Gäste reservieren jetzt direkt online statt anzurufen — das entlastet uns jeden Abend.",
    name: "Elena K.",
    role: "Restaurantleitung, Ratingen",
    metric: "+65 % Online-Reservierungen",
  },
  {
    quote:
      "Von der ersten Mail bis zum Launch: schnell, ehrlich, verlässlich. Und wenn ich etwas geändert haben will, ist es meist am selben Tag erledigt.",
    name: "Dr. S. Hoffmann",
    role: "Zahnarztpraxis, Essen",
    metric: "Antwort immer < 24 h",
  },
];

export default function Testimonials() {
  return (
    <section className="py-20 md:py-32 bg-[#F8F9FA] border-y border-[#E4E4E7]">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <Reveal>
          <SectionLabel number="06" label="Kundenstimmen" />
          <h2 className="font-display font-medium text-3xl md:text-4xl lg:text-5xl tracking-tight max-w-2xl">
            Was Kunden nach dem Launch sagen.
          </h2>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.12}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="h-full rounded-2xl bg-white border border-[#E4E4E7] p-8 flex flex-col hover:shadow-[0_20px_50px_-24px_rgba(10,10,10,0.15)] transition-shadow duration-300"
              >
                <span className="flex text-amber-400 mb-5 text-sm" aria-label="5 von 5 Sternen">★★★★★</span>
                <blockquote className="text-[15px] leading-relaxed flex-1">„{t.quote}"</blockquote>
                <figcaption className="mt-6 pt-6 border-t border-[#E4E4E7]">
                  <p className="font-semibold text-sm">{t.name}</p>
                  <p className="text-xs text-[#A1A1AA] mt-0.5">{t.role}</p>
                  <p className="font-mono text-xs text-[#2563EB] font-medium mt-3">{t.metric}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
